import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { BaseApiResponse, SpiritoryWebEndpoints } from '@/types/api/api-v2';
import { BlogPost } from '@/types/Blog';
import { getValidLocale } from '@/utilites/language/language.utils';

export default async function getBlogPostByDocumentId(
  documentId: string,
  locale: string = 'en'
) {
  try {
    const validLocale = getValidLocale(locale);
    const finalURL = `/blog/documentId/${documentId}?locale=${validLocale}`;
    const {
      data: { data },
    } = await spiritoryWebApi.get<BaseApiResponse<BlogPost>>(
      finalURL as SpiritoryWebEndpoints
    );

    return data;
  } catch (e) {
    throw e;
  }
}
